// src/pages/Fleet.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Fleet.css';

const Fleet = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleManageFleet = () => {
    const token = localStorage.getItem('marilink_token');
    if (token) navigate('/owner/my-ships');
    else navigate('/login', { state: { from: '/owner/my-ships' } });
  };

  const vesselTypes = [
    { icon: 'fa-ship', name: 'Container Ships', count: '2,500+', description: 'Global container fleet management' },
    { icon: 'fa-oil-can', name: 'Oil Tankers', count: '1,800+', description: 'Crude & product tankers' },
    { icon: 'fa-fire', name: 'LNG Carriers', count: '600+', description: 'Liquefied natural gas vessels' },
    { icon: 'fa-truck', name: 'Bulk Carriers', count: '3,200+', description: 'Dry bulk cargo vessels' }
  ];

  return (
    <div className="fl-page">
      <nav className="fl-navbar">
        <div className="fl-nav-container">
          <div className="fl-logo" onClick={() => navigate('/')}>Sea<span>Zex</span></div>
          <div className="fl-nav-links">
            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/ship-owners'); }}>Ship Owners</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/service-providers'); }}>Providers</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/services'); }}>Services</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/fleet'); }} className="active">Fleet</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/how-it-works'); }}>How it Works</a>
            <button className="fl-btn-secondary" onClick={() => navigate('/login')}>Log In</button>
            <button className="fl-btn-primary" onClick={() => navigate('/register')}>Register</button>
          </div>
        </div>
      </nav>

      <section className="fl-hero">
        <div className="fl-container-inner">
          <div className="fl-hero-content">
            <h1 className="fl-hero-title">Manage Your <span className="fl-highlight">Fleet</span> Efficiently</h1>
            <p className="fl-hero-subtitle">Centralized fleet management for ship owners. Track vessels, maintenance, and service history.</p>
            <button className="fl-btn-primary fl-btn-large" onClick={handleManageFleet}>Manage My Fleet <i className="fas fa-arrow-right"></i></button>
          </div>
        </div>
      </section>

      <section className="fl-stats">
        <div className="fl-container-inner">
          <div className="fl-stats-grid">
            <div className="fl-stat-item"><div className="fl-stat-number">10,000+</div><div className="fl-stat-label">Vessels Tracked</div></div>
            <div className="fl-stat-item"><div className="fl-stat-number">500+</div><div className="fl-stat-label">Ports Covered</div></div>
            <div className="fl-stat-item"><div className="fl-stat-number">1,200+</div><div className="fl-stat-label">Jobs Completed</div></div>
            <div className="fl-stat-item"><div className="fl-stat-number">94%</div><div className="fl-stat-label">Satisfaction</div></div>
          </div>
        </div>
      </section>

      <section className="fl-vessels">
        <div className="fl-container-inner">
          <div className="fl-section-header">
            <span className="fl-section-tag">Vessel Types</span>
            <h2>We Support All Vessel Types</h2>
          </div>
          <div className="fl-vessels-grid">
            {vesselTypes.map((vt, idx) => (
              <div key={idx} className="fl-vessel-card">
                <div className="fl-vessel-icon"><i className={`fas ${vt.icon}`}></i></div>
                <h3>{vt.name}</h3>
                <p>{vt.description}</p>
                <span className="fl-vessel-count">{vt.count} active</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="fl-features">
        <div className="fl-container-inner">
          <div className="fl-section-header">
            <span className="fl-section-tag">Fleet Management</span>
            <h2>Powerful Tools for Fleet Owners</h2>
          </div>
          <div className="fl-features-grid">
            <div className="fl-feature-card"><div className="fl-feature-icon"><i className="fas fa-chart-line"></i></div><h3>Real-time Tracking</h3><p>Monitor vessel positions and service status</p></div>
            <div className="fl-feature-card"><div className="fl-feature-icon"><i className="fas fa-certificate"></i></div><h3>Certificate Management</h3><p>Track expiring certificates and get alerts</p></div>
            <div className="fl-feature-card"><div className="fl-feature-icon"><i className="fas fa-history"></i></div><h3>Service History</h3><p>Complete maintenance and service records</p></div>
          </div>
        </div>
      </section>

      <footer className="fl-footer">{/* Footer */}</footer>
    </div>
  );
};

export default Fleet;